/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit EffectiveDate/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import React from 'react'
import Status from './Status/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function EffectiveDate({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Insurance/AssignedInsurance/Content/AssignedInsuranceItem/EffectiveDate"
  
}) {
let assignedInsuranceInsuranceSubscriptionEnrollmentDateValueData = fromData.useDataValue({ viewPath,
context: 'assigned_insurance',
path: 'insurance_subscription.enrollment_date',
})
let constantData = '–'
let aggregateData = fromAggregate.any(assignedInsuranceInsuranceSubscriptionEnrollmentDateValueData, constantData)
  return (<React.Fragment
>
<div
  data-testid="EffectiveDate.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="assigned_insurance.insurance_subscription.enrollment_date"
 data="'–'"
 aggregate="/Data/aggregate.js any"
 text={aggregateData}
/>
<Status
  viewPath={`${viewPath}/Status`}
/>
</div>
{children}
</React.Fragment>)
}